export var RestoreAccountTagOperator;
(function (RestoreAccountTagOperator) {
    RestoreAccountTagOperator["RESTORE_ACCOUNT_TAG_OPERATOR_CONTAINS_ANY_OF"] = "CONTAINS_ANY_OF";
    RestoreAccountTagOperator["RESTORE_ACCOUNT_TAG_OPERATOR_CONTAINS_ALL_OF"] = "CONTAINS_ALL_OF";
    RestoreAccountTagOperator["RESTORE_ACCOUNT_TAG_OPERATOR_CONTAINS_NONE_OF"] = "CONTAINS_NONE_OF";
})(RestoreAccountTagOperator || (RestoreAccountTagOperator = {}));
